import { useEffect, useState } from "react";
export function usePaymentInstrumentToken(token) {
  const {
    0: payload,
    1: setPayload
  } = useState(null);
  useEffect(() => {
    if (token) {
      fetch("/api/payment_instrument_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          token
        })
      }).then(res => res.json()).then(json => setPayload(json));
    }
  }, [token]);
  return payload;
}